import { SET_CUSTOM_FORM_DATA } from 'actions';
import { ICustomForm } from 'typings';

export function setCustomFormData(customForm: ICustomForm) {
  return { customForm, type: SET_CUSTOM_FORM_DATA };
}
